import { Cash100Icon } from './Cash100Icon';

/**
 * author: Google
 * id 18E513D3-5D34-4A4B-B600-D7173CB30DDA
 * name cash-100
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cash-100.svg
 * tags
 * - Currency 
 * - Banking 
 */
export const Money100Icon = Cash100Icon;
export default Money100Icon